<div [ngClass]="{'hidden': isHidden}">
  <h1 *ngIf="showLabel && inputType !== INPUT_TYPES.BOOL" class="dynamic-input-title">{{campo.titulo}} <span
    *ngIf="required">*</span></h1>
  <div *ngIf="campo.codigo === 'descricao.termo.aceite.sms' && campo.descricao" [innerHTML]="campo.descricao" class="dynamic-input-description"></div>
  <app-input-text
    *ngIf="isInputText" 
    [campo]="campo"
    [currentFormControl]="currentFormControl"
    [readOnly]="readOnly"
    [requestFocus]="requestFocus"
    [isCepLoading]="isCepLoading && this.campo.codigo === 'pessoa.endereco.cep'"
    >
  </app-input-text>
  <app-input-dropdown
    *ngIf="isInputDropdown"
    [campo]="campo"
    [currentFormControl]="currentFormControl"
    [readOnly]="readOnly"
    [requestFocus]="requestFocus"
    (typeSelected)="onTypeChange($event)">
  </app-input-dropdown>
  <app-input-date
    *ngIf="isInputDate"
    [campo]="campo"
    [currentFormControl]="currentFormControl"
    [readOnly]="readOnly"
    [requestFocus]="requestFocus">
  </app-input-date>
  <app-input-checkbox
    *ngIf="isInputCheckbox"
    [campo]="campo"
    [currentFormControl]="currentFormControl">
  </app-input-checkbox>
  <app-image-capture-input
    *ngIf="isInputImage"
    [isSelf]="isSelfie"
    [field]="campo"
    [form]="form"
    [formGroup]="formGroup"
    [hideSideName]="true">
  </app-image-capture-input>
  <app-input-otp
    *ngIf="isInputOtp"
    [campo]="campo"
    [currentFormControl]="currentFormControl"
    [readOnly]="readOnly"
    [requestFocus]="requestFocus">
  </app-input-otp>
</div>
